import React from 'react';

interface SuperProps {
  children?: React.ReactNode;
}

const Super = ({ children = null, ...rest }: SuperProps) => {
  return (
    <span
      {...rest}
      style={{
        verticalAlign: 'super',
        fontSize: '0.625em',
      }}
    >
      {children}
    </span>
  );
};

export default Super;
